<template>
    <div style="width: 100%">
        <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules" inline>
            <FormItem label="材料名称" prop="name" class="my-form-item">
                <Input v-model="formItem.name" placeholder="请输入姓名" class="my-form-input"></Input>
            </FormItem>
            <FormItem label="所属目录" prop="catalogId" class="my-form-item">
                <Select v-model="formItem.catalogId" filterable class="my-form-input">
                    <Option v-for="item in catalogList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                </Select>
            </FormItem>
            <FormItem label="材料号" prop="matNumber" class="my-form-item">
                <Input v-model="formItem.matNumber" placeholder="请输入材料号" class="my-form-input"></Input>
            </FormItem>
            <FormItem label="规  格" prop="matSpec" class="my-form-item">
                <Input v-model="formItem.matSpec" placeholder="请输入规格" class="my-form-input"></Input>
            </FormItem>
            <FormItem label="单  位" prop="unitName" class="my-form-item">
                <Select v-model="formItem.unitName" filterable class="my-form-input">
                    <Option v-for="item in unitList" :value="item.dictName" :key="item.id">{{ item.dictName }}</Option>
                </Select>
            </FormItem>
            <FormItem label="品  牌" prop="brand" class="my-form-item">
                <Input v-model="formItem.brand" placeholder="请输入品牌" class="my-form-input"></Input>
            </FormItem>
            <FormItem label="售价(元)" prop="sellPrice" class="my-form-item">
                <Input type="number" v-model="formItem.sellPrice" placeholder="请输入出库价" class="my-form-input"></Input>
            </FormItem>
            <FormItem label="备注" prop="remark" class="my-form-item">
                <Input v-model="formItem.remark" placeholder="请输入备注" class="my-form-input"></Input>
            </FormItem>
        </Form>
        <div slot="footer" style="text-align: right">
            <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
            <Button @click="handleCancel">取消</Button>
        </div>
    </div>
</template>

<script>
import {queryMaterialsCatalogList, saveMaterialsInfo} from "@/api/baseData"
import {queryDictList} from "@/api"

export default {
    name: "NewMaterials",
    props: {
        materInfo: {
            type: Object,
        },
    },
    data() {
        return {
            formItem: {
                name: '',
                remark: '',
                catalogId: '',
                matNumber: '',
                matSpec: '',
                unitName: '',
                brand: '',
                sellPrice: '',
            },
            rules: {
                name: [
                    {required: true, message: '材料名称不能为空', trigger: 'blur'},
                ],
                catalogId: [
                    {required: true, message: '所属目录不能为空', trigger: 'blur'},
                ],
                unitName: [
                    {required: true, message: '单位不能为空', trigger: 'blur'},
                ],
                sellPrice: [
                    {required: true, message: '售价不能为空', trigger: 'blur'},
                ],
            },
            loading: false,
            catalogList: [],
            unitList: [],
        }
    },
    mounted() {
        if (this.materInfo.id) {
            this.formItem = Object.assign({}, this.materInfo)
            this.formItem.sellPrice += ''
        }
        this.initInfo()
    },
    methods: {
        async initInfo() {
            let {data} = await queryDictList({classCode: 'materials_unit'})
            this.unitList = data
            queryMaterialsCatalogList({}).then((res) => {
                this.catalogList = res.data
            })
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate((valid) => {
                if (valid) {
                    saveMaterialsInfo(this.formItem).then(() => {
                        this.$emit('handleClose', true)
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.$emit('handleClose', false)
        },
    },
}
</script>

<style scoped>
.my-form-item {
    margin-left: 20px;
}

.my-form-input {
    width: 260px;
}
</style>
